import HandIcon from 'assets/images/easyPay/hand.svg'
import useGetAllPayments from './hooks/useGetAllPayments'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import useSetTotalPayment from './hooks/useSetTotalPayment'
import Footer from './footer'
import Header from 'components/headers/easyPay'
import { Form } from 'react-bootstrap'
import FooterAllPayGateway from './footer/indexFooterGateway'

export default function EasyGatewayPay() {
    const {
        payments,
        isLoading,
        handleSelectAllPayments,
        isAllSelected,
        handleSelectSpecificPayment,
    } = useGetAllPayments(true)
    const { total, commission } = useSetTotalPayment(payments)
    return (
        <>
            {isLoading ? (
                <DotsLoading />
            ) : (
                <div className="flex flex-col relative h-screen">
                    <div className="grow-0">
                        <Header title="پرداخت آسان از طریق درگاه" />
                    </div>
                    <div className="grow">
                        <img
                            src={HandIcon}
                            alt="hand"
                            className="mx-auto -mb-10 z-50"
                        />
                        <div className="bg-white shadow-soft rounded-xl px-3 pt-3 pb-8 mx-4  overflow-y-auto max-h-[32rem]">
                            <div className="flex justify-between mt-4">
                                <p className="">انتخاب همه</p>
                                <Form.Check
                                    type="checkbox"
                                    id={`check-api-checkbox`}
                                    className=" mx-2"
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        isValid
                                        checked={isAllSelected}
                                        onChange={handleSelectAllPayments}
                                    />
                                </Form.Check>
                            </div>
                            {payments &&
                                payments?.map((item) => (
                                    <Item
                                        key={item.id}
                                        item={item}
                                        isSelected={item.isSelected}
                                        handleSelectSpecificPayment={
                                            handleSelectSpecificPayment
                                        }
                                    />
                                ))}
                        </div>
                    </div>
                    <div className="grow-0">
                        <FooterAllPayGateway
                            commission={commission}
                            total={total}
                            toBePaidTransactions={payments.filter(
                                (i) => i.isSelected
                            )}
                        />
                    </div>
                </div>
            )}
        </>
    )
}
